module.exports = __webpack_public_path__ + "img/branco - cinza.e320aabc.svg";